import { Component } from '@theme/component';

/**
 * Header actions component that manages the product switcher dropdown.
 *
 * @typedef {object} Refs
 * @property {HTMLDetailsElement} details - The product switcher details element.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['details'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this.#onDocumentClick);
    document.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#onDocumentClick);
    document.removeEventListener('keydown', this.#onKeydown);
  }

  /**
   * Closes the switcher when clicking outside of it.
   * @param {MouseEvent} event
   */
  #onDocumentClick = (event) => {
    if (!this.refs.details.open) return;
    if (event.target instanceof Node && this.contains(event.target)) return;
    this.refs.details.open = false;
  };

  /**
   * Closes the switcher when Escape is pressed.
   * @param {KeyboardEvent} event
   */
  #onKeydown = (event) => {
    if (event.key !== 'Escape' || !this.refs.details.open) return;
    this.refs.details.open = false;
    this.refs.details.querySelector('summary')?.focus();
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
